<template>
  <div>
    <LmButton
      class="mt-3"
      :value="permissionsExpanded ? 'Ocultar permisos de usuario' : 'Mostrar permisos de usuario'"
      :buttonClass="showBadge ? 'btn-primary' : 'btn-secondary'"
      lmButtonRootWrapperClass="d-inline-block"
      type="button"
      size="sm"
      :icon="showBadge ? 'exclamation-circle' : ''"
      @click="permissionsExpanded = !permissionsExpanded"
      v-b-toggle.permissionsOptions
    />
    <b-collapse id="permissionsOptions" v-if="Object.keys(value).length">
      <div
        v-for="(permission, key) in value"
        :key="key"
      >
        <div v-if="show(key)">
          <LmTreeSelect
            class="col-12 mb-2 px-0"
            v-model="value[key]"
            :defaultValue="defaultValue[key] || null"
            :label="setLabel(key) || key"
            :options="optionsData"
            multiple
          />
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
// Components
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'

// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    usedIn: {
      type: String,
      default: ''
    },
    titleButton: {
      type: String,
      default: ''
    },
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      pathToGetUsers: process?.env?.VUE_APP_USER_PRIVILEGES_PATH || '/codificatorbuilder/codificators/60ef50e476b81943ec4d99da',
      permissionsExpanded: false,
      defaultValue: {},
      data: {},
      optionsData: null
    }
  },
  components: {
    LmButton,
    LmTreeSelect
  },
  computed: {
    isOnEditMode () {
      return !!this.$route?.params?.id
    },
    showBadge () {
      // Muestro le badge el boton si hay al menos un privilegio y este no se encuentra oculto
      let showBadge
      for (const key in this.value) {
        showBadge = !!this.value[key].length && !(key in this.settings && this.settings[key]?.show === false)
        if (showBadge) return true
      }
      return false
    }
  },
  methods: {
    setLabel (payload) {
      if (payload in this.settings) {
        return this.settings[payload]?.label
      }
    },
    show (payload) {
      if (payload in this.settings) {
        return this.settings[payload]?.show !== undefined ? this.settings[payload]?.show : true
      }
      return true
    }
  },
  async created () {
    const { data } = await commonsApi.axiosGetWrapper(this.pathToGetUsers)
    this.optionsData = data.items

    // Solo en modo edición
    // Configuro el default value
    if (!this.isOnEditMode) {
      for (const key in this.value) {
        this.defaultValue[key] = []
      }
      // Reviso si hay valores por defecto, los seteo y emito estos valores
      for (const key in this.settings) {
        if (this.settings[key]?.default) {
          const item = this.optionsData.find(o => this.settings[key]?.default.includes(o.codigo_privilegio)) || null
          if (item) {
            this.defaultValue[key].push(item)
          }
        }
      }
      // Si no hago este $emit, no aplica los default de los campos ocultos
      this.$emit('input', this.defaultValue)
    }
  }
}
</script>
